// Mutations
export const RESETTEAMS = 'RESETTEAMS';

// Actions
export const ADDTEAM = 'ADDTEAM';
export const EDITTEAM = 'EDITTEAM';
export const REMOVETEAM = 'REMOVETEAM';
export const COPYFROMPREVIOUSLOCKOUT = 'COPYFROMPREVIOUSLOCKOUT';

import db from '../../firebase/firebase'
import {
  compareByName, insertByComparison } from '../../functions/general'
import {
  removeBound,
  updateBound } from '../helpers/binding'
import { snapshot2object } from '../helpers/general';
import { generateUpdatesForObject } from '../helpers/updates'

export default {
  state: () => ({
    teams: [],
  }),

  getters: {
  },

  mutations: {
    addBoundTeam: ( state, { snapshot } ) => {
      let team = snapshot2object( snapshot )
      insertByComparison( state.teams, team, compareByName )
    },
    removeBoundTeam: ( state, { snapshot } ) => removeBound( state.teams, snapshot ),
    updateBoundTeam: ( state, { snapshot } ) => updateBound( state.teams, snapshot ),

    [RESETTEAMS] ( state ) {
      state.teams = []
    },
  },

  actions: {
    [ADDTEAM] ( context, { lockout, newteamname, badgeicon, badgecolor } ) {
      if( lockout ) {
        let team = { name: newteamname, badgeicon: badgeicon, badgecolor: badgecolor }
        return db.ref( 'lockouts/' + lockout['.key'] +
                       '/teams' ).push( team )
      }
    },
    [EDITTEAM] ( context, { lockout, team, newvalues } ) {
      if( lockout && team ) {
        let updates = generateUpdatesForObject(
          'lockouts/' + lockout['.key'] +
          '/teams/' + team['.key'] + '/', newvalues )
      
        return db.ref().update( updates )
      }
    },
    [REMOVETEAM] ( { rootState }, { lockout, team } ) {
      if( lockout ) {
        var updates = {};
        updates[ '/teams/' + team['.key'] ] = null

        // Unplan all signups for this team
        let teamsigns = rootState.signups.signups.filter( s => s.team == team['.key'] )
        for( var sign of teamsigns ) {
          updates[ '/signups/' + sign['.key'] + '/team' ] = null
          updates[ '/signups/' + sign['.key'] + '/state' ] = null
        }

        // Remove team from all raidevents
        let eventinteam = rootState.raidevents.raidevents.filter(
          e => e.teams && e.teams[ team['.key'] ] )

        for( var event of eventinteam ) {
          updates[ '/raidevents/' + event['.key'] +
                   '/teams/' + team['.key'] ] = null
        }

        return db.ref( 'lockouts/' + lockout['.key'] ).update( updates )
      }
    },
    async [COPYFROMPREVIOUSLOCKOUT]( { state, rootState, dispatch } ) {
      // Only if no teams exist yet
      if( state.teams.length > 0 ) return

      // Get the key of the previous lockout
      let lockout = rootState.lockouts.selectedLockout
      let lockouts = rootState.lockouts.lockouts
      let indexOfLockout = lockouts.findIndex( l => l['.key'] == lockout['.key'] )
      if( indexOfLockout < 0 || indexOfLockout + 1 == lockouts.length ) return
      let prevLockout = lockouts[indexOfLockout + 1]

      // Fetch the teams of the previous lockout
      let teamsPrevLockoutSnapshot = await db.ref( 'lockouts/' +
        prevLockout['.key'] + '/teams' ).get()
      
      let teamsPrevLockout = teamsPrevLockoutSnapshot.val()

      // Traverse over all the teams and add them to the current lockout
      for( let teamKey in teamsPrevLockout ) {
        let team = teamsPrevLockout[teamKey]

        await dispatch( ADDTEAM, { lockout: lockout,
                                   newteamname: team.name,
                                   badgeicon: team.badgeicon,
                                   badgecolor: team.badgecolor } )
      }

    },
  },
}